import axios from "axios";

async function getProjects() {

  let response=await axios.get('https://api.tacarmuhendislik.com/taha')
      return response.data;
    
   
}
async function postt(requets) {


let response =await axios.post('https://api.tacarmuhendislik.com/api/projects', requets, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});
return response;
}


export async function getProjectById(id) {

  let response=await axios.get(`https://api.tacarmuhendislik.com/taha/${id}`)
  console.log(response.data);
  return response.data;
}

export async function sendEmail(requets) {

  let response=await axios.post('https://api.tacarmuhendislik.com/api/sendmail',requets)
  console.log(response.data);
  return response.data;
}

export async function deleteProject(id) {

  let response=await axios.delete(`https://api.tacarmuhendislik.com/api/projects/${id}`)
    return response;

}




export async function updateProjectservice(updatedProject) {



let response =await axios.put('https://api.tacarmuhendislik.com/taha/taha', updatedProject, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});
console.log(response);
return response;
}



export default getProjects;
export { postt};